import React from 'react';
import './Privacy.css';
import { Seo, buildBreadcrumbSchema } from '../components/Seo';
import { siteInfo } from '../data/siteInfo';

function Privacy() {
  return (
    <div className='privacy-page'>
      <Seo
        title='Datenschutzerklärung'
        description="Datenschutzerklärung von Sarita's Cafe & Bistro in Hinwil nach dem Schweizer Datenschutzgesetz."
        path='/datenschutz'
        schema={[
          buildBreadcrumbSchema([
            { name: 'Startseite', path: '/' },
            { name: 'Datenschutzerklärung', path: '/datenschutz' }
          ])
        ]}
      />

      <header className='page-hero privacy-hero'>
        <div className='container page-hero__content'>
          <h1 className='page-hero__title'>Datenschutzerklärung</h1>
        </div>
      </header>

      <section className='section-shell privacy-content-section'>
        <div className='container'>
          <article className='privacy-content panel-surface'>
            <p className='section-eyebrow'>Schweizer Datenschutzgesetz</p>
            <p className='privacy-content__lead'>
              Diese Datenschutzerklärung informiert darüber, wie Sarita&apos;s Cafe & Bistro Personendaten
              bearbeitet, wenn Sie unsere Website besuchen, mit uns Kontakt aufnehmen oder unsere
              Angebote nutzen. Massgebend ist insbesondere das Schweizer Datenschutzgesetz (DSG).
            </p>
            <p className='privacy-content__updated'>Stand: 26. April 2026</p>

            <section className='privacy-section'>
              <h2>1. Verantwortliche Stelle</h2>
              <p>
                Verantwortlich für die Bearbeitung von Personendaten ist:
              </p>
              <address>
                Sarita&apos;s Cafe & Bistro<br />
                Sarah Ehrismann<br />
                {siteInfo.addressLine1}<br />
                {siteInfo.addressLine2}<br />
                Schweiz
              </address>
              <p>
                Telefon: <a href={siteInfo.phoneHref}>{siteInfo.phone}</a><br />
                E-Mail: <a href={`mailto:${siteInfo.email}`}>{siteInfo.email}</a>
              </p>
            </section>

            <section className='privacy-section'>
              <h2>2. Welche Personendaten wir bearbeiten</h2>
              <p>
                Je nach Nutzung unserer Website oder unserer Angebote bearbeiten wir insbesondere folgende
                Daten:
              </p>
              <ul>
                <li>Kontaktdaten wie Name, E-Mail-Adresse, Telefonnummer und Inhalt Ihrer Nachricht.</li>
                <li>Technische Daten wie IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seiten, Browser, Betriebssystem und Referrer-URL.</li>
                <li>Nutzungsdaten aus Google Analytics, zum Beispiel besuchte Seiten, Verweildauer und Interaktionen.</li>
                <li>Daten, die beim Aufruf eingebundener Dienste wie Google Maps oder Google Fonts entstehen.</li>
                <li>Daten aus Bestellungen, Reservationen, Gutscheinen oder weiteren Anfragen, sofern Sie uns diese mitteilen.</li>
              </ul>
            </section>

            <section className='privacy-section'>
              <h2>3. Zwecke der Bearbeitung</h2>
              <p>
                Wir bearbeiten Personendaten, soweit dies für die folgenden Zwecke erforderlich ist:
              </p>
              <ul>
                <li>Bereitstellung, Sicherheit und technische Optimierung der Website.</li>
                <li>Beantwortung von Anfragen per E-Mail, Telefon oder über andere Kontaktwege.</li>
                <li>Abwicklung von Bestellungen, Reservationen, Gutscheinen oder ähnlichen Kundenanliegen.</li>
                <li>Analyse der Website-Nutzung mit Google Analytics.</li>
                <li>Anzeige unseres Standorts über Google Maps.</li>
                <li>Erfüllung gesetzlicher Pflichten und Durchsetzung oder Abwehr von Rechtsansprüchen.</li>
              </ul>
            </section>

            <section className='privacy-section'>
              <h2>4. Website-Betrieb und Hosting</h2>
              <p>
                Unsere Website wird über technische Dienstleister betrieben. Beim Besuch der Website können
                Server-Logdaten entstehen, insbesondere IP-Adresse, Zeitpunkt des Zugriffs, aufgerufene
                Datei, Browserinformationen und übertragene Datenmenge. Diese Daten werden zur
                Auslieferung der Website, zur Stabilität, zur Fehlersuche und zur Sicherheit verarbeitet.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>5. Cookies und ähnliche Technologien</h2>
              <p>
                Unsere Website kann Cookies oder ähnliche Technologien verwenden, die für den Betrieb,
                die Darstellung oder die Analyse der Website erforderlich sind. Sie können Cookies in den
                Einstellungen Ihres Browsers einschränken oder löschen. Dadurch können einzelne Funktionen
                der Website eingeschränkt sein.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>6. Google Analytics</h2>
              <p>
                Wir nutzen Google Analytics 4, um die Nutzung der Website statistisch auszuwerten und
                unser Angebot zu verbessern. Anbieter ist Google Ireland Limited, Gordon House, Barrow
                Street, Dublin 4, Irland. Dabei können Daten auch an Google LLC in den USA übermittelt
                werden.
              </p>
              <p>
                Google kann Cookies und ähnliche Technologien einsetzen und Daten wie IP-Adresse,
                Geräte- und Browserinformationen, besuchte Seiten, Verweildauer und Interaktionen
                bearbeiten. Sie können die Speicherung von Cookies über Ihre Browser-Einstellungen
                verhindern oder ein Browser-Add-on zur Deaktivierung von Google Analytics verwenden.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>7. Google Fonts und Google Maps</h2>
              <p>
                Zur Darstellung der Website verwenden wir Google Fonts. Beim Laden der Schriften können
                technische Daten wie Ihre IP-Adresse an Google übermittelt werden.
              </p>
              <p>
                Auf der Kontaktseite binden wir Google Maps ein, damit Sie unseren Standort einfacher
                finden. Wenn Sie die Karte aufrufen, kann Google technische Daten und Nutzungsdaten
                bearbeiten. Anbieter ist Google Ireland Limited; Daten können auch an Google LLC in den
                USA übermittelt werden.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>8. Instagram und externe Links</h2>
              <p>
                Unsere Website enthält Links zu unserem Instagram-Profil und zu externen Angeboten. Wenn
                Sie solche Links anklicken, verlassen Sie unsere Website. Für die anschliessende Bearbeitung
                von Personendaten sind die jeweiligen Anbieter verantwortlich.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>9. Weitergabe an Dritte und Übermittlung ins Ausland</h2>
              <p>
                Wir geben Personendaten nur weiter, wenn dies für die genannten Zwecke erforderlich ist,
                eine gesetzliche Pflicht besteht oder Sie eingewilligt haben. Empfänger können insbesondere
                Hosting-Anbieter, IT-Dienstleister, Kommunikationsdienste, Google, Meta/Instagram sowie
                Behörden im gesetzlich vorgesehenen Rahmen sein.
              </p>
              <p>
                Daten können in der Schweiz, in der EU, im EWR und in weiteren Ländern, insbesondere den
                USA, bearbeitet werden. Erfolgt eine Übermittlung in ein Land ohne angemessenes
                Datenschutzniveau, sorgen wir soweit erforderlich für geeignete Garantien, zum Beispiel
                Standarddatenschutzklauseln, oder stützen uns auf gesetzliche Ausnahmen. Für zertifizierte
                US-Unternehmen kann das Swiss-U.S. Data Privacy Framework ein angemessenes
                Datenschutzniveau gewährleisten.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>10. Aufbewahrung</h2>
              <p>
                Wir speichern Personendaten nur so lange, wie es für den jeweiligen Zweck erforderlich ist,
                gesetzliche Aufbewahrungspflichten bestehen oder berechtigte Interessen an der Speicherung
                vorliegen. Kontaktanfragen werden in der Regel gelöscht, sobald sie erledigt sind und keine
                gesetzlichen oder geschäftlichen Aufbewahrungsgründe mehr bestehen.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>11. Datensicherheit</h2>
              <p>
                Wir treffen angemessene technische und organisatorische Massnahmen, um Personendaten
                gegen Verlust, Missbrauch, unbefugten Zugriff, Veränderung oder Offenlegung zu schützen.
                Eine Datenübertragung im Internet kann jedoch nie vollständig sicher sein.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>12. Ihre Rechte</h2>
              <p>
                Sie können im Rahmen des anwendbaren Datenschutzrechts Auskunft über Ihre Personendaten
                verlangen sowie deren Berichtigung, Löschung, Einschränkung der Bearbeitung oder
                Herausgabe bzw. Übertragung verlangen. Sie können zudem einer Bearbeitung widersprechen
                oder eine erteilte Einwilligung mit Wirkung für die Zukunft widerrufen.
              </p>
              <p>
                Zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte über die oben genannten Kontaktdaten.
                Zur Bearbeitung Ihrer Anfrage kann ein Identitätsnachweis erforderlich sein.
              </p>
            </section>

            <section className='privacy-section'>
              <h2>13. Änderungen</h2>
              <p>
                Wir können diese Datenschutzerklärung jederzeit anpassen, wenn sich unsere Datenbearbeitung,
                die eingesetzten Dienste oder die Rechtslage ändern. Es gilt die jeweils auf dieser Website
                veröffentlichte Fassung.
              </p>
            </section>
          </article>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
